import { useAuthUserStore } from '@/app/stores/user';

// @ts-ignore
export default async function auth({ next }) {
  const authUserStore = useAuthUserStore();
  if (!authUserStore.user.id || !authUserStore.authorized) await authUserStore.getUser();
  if (authUserStore.isUserNotFound) return next();
  if (!authUserStore.authorized) {
    return authUserStore.logoutToPinCode();
  }

  return next();
}
